module.exports = __webpack_public_path__ + "assets/9c90be12a3c7bda66d9164cab05facd8.mp3";